import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../common/pagination";
import ModernPagination from "../../../common/pagination/ModernPagination";
import Heading from '../../../common/element/Heading';
import ClientInput from "../../../common/element/Input/clientInput";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import AddEditCompany from './AddEdit';
import EmployeeList from './Employee';
import ImportEmployee from './ImportCsv';
import { getEmployeesList } from '../../../redux/Employee/employeesSlice';
import { selectEmployeesList, selectEmployeesListLoading, selectEmployeesListTotal } from '../../../redux/Employee/employeesSelector';

const Employee = () => {
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [allEmployeesData, setAllEmployeesData] = useState([]);

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,

    search: "",
  });
  const employees = useSelector(selectEmployeesList);
  const employeesTotal = useSelector(selectEmployeesListTotal);
  const employeesLoading = useSelector(selectEmployeesListLoading);
  console.log(employees, "employeesemployeesemployees")
  // Search Data
  const handlePageChange = (page) => {
    setfilterpage(page);
    SetFilterData((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setfilterlimit(limit);
    setfilterpage(1);
    SetFilterData((prev) => ({ ...prev, limit, page: 1 }));
  };

  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Employees",
          url: "/employee",
          home: "/companies",
        },
      ])
    );
  }, [dispatch]);
  useEffect(() => {
    setAllEmployeesData(employees || []);
    const total = employeesTotal || employees?.length || 0;
    setCountData(total);
    setTotalPages(Math.max(1, Math.ceil(total / (filterlimit || 10))));
  }, [employees, employeesTotal, filterlimit]);
  const inputchangehandler = useCallback(debounce(handleSearch), []);
  // Fetch Employees
  const { page, limit, search, sort, order } = getFilterData;

  const fetchEmployees = useCallback(() => {

    dispatch(
      getEmployeesList({

        page,
        limit,
        search,
        sort,
        order,
      })
    );
  }, [dispatch, page, limit, search, sort, order]);

  // Effects
  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  const handleEdit = (company) => {
    console.log(company, "companycompany")
    setSelectedCompany(company);
    setIsEdit(true);
    setDialogOpen(true);
  };

  const handleAddNew = () => {
    setSelectedCompany(null);
    setIsEdit(false);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedCompany(null);
    setIsEdit(false);
  };

  const handleImport = () => {
    setImportDialogOpen(true);
  };

  const handleImportDialogClose = () => {
    setImportDialogOpen(false);
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3">
        </p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Employees</Heading>
        </div>

        <div className="flex gap-2">
          <div className="relative group">
            <a href="/employees_format.csv" download="employees_format.csv">  <BtnPrimary
              // onClick={handleImport}
              className="gap-1"
            >
              <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.8 6.08125C16.9281 5.74688 17 5.38125 17 5C17 3.34375 15.6562 2 14 2C13.3844 2 12.8094 2.1875 12.3344 2.50625C11.4688 1.00625 9.85312 0 8 0C5.2375 0 3 2.2375 3 5C3 5.08437 3.00312 5.16875 3.00625 5.25313C1.25625 5.86875 0 7.5375 0 9.5C0 11.9844 2.01562 14 4.5 14H16C18.2094 14 20 12.2094 20 10C20 8.06563 18.625 6.45 16.8 6.08125ZM12.6469 8.85312L9.35312 12.1469C9.15937 12.3406 8.84063 12.3406 8.64688 12.1469L5.35313 8.85312C5.0375 8.5375 5.2625 8 5.70625 8H7.75V4.5C7.75 4.225 7.975 4 8.25 4H9.75C10.025 4 10.25 4.225 10.25 4.5V8H12.2937C12.7375 8 12.9625 8.5375 12.6469 8.85312Z" fill="white" />
              </svg>
            </BtnPrimary></a>


            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pointer-events-none z-10">
              Download CSV File Format
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900"></div>
            </div>
          </div>
          <BtnPrimary
            onClick={handleImport}
            className="gap-1 whitespace-nowrap"
          >
            Import Csv
          </BtnPrimary>
          <BtnPrimary
            onClick={handleAddNew}
            className="text-xs h-9 flex items-center justify-center px-3 gap-1 whitespace-nowrap"
          >
            Add Employee
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <EmployeeList
        employeesListData={employees}
        onEdit={handleEdit}
        employeesLoading={employeesLoading}
        fetchEmployees={fetchEmployees}
        // 👇 ADD THESE TWO PROPS 👇
        currentPage={filterpage}
        itemsPerPage={filterlimit}
      />

      <AddEditCompany
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        employeeData={selectedCompany}
        isEdit={isEdit}
        fetchEmployees={fetchEmployees}
      />

      <ImportEmployee
        dialogOpen={importDialogOpen}
        onDialogClose={handleImportDialogClose}
        fetchEmployees={fetchEmployees}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={allEmployeesData?.length}
          UpdatePageLimit={handleLimitChange}
          UpdatePage={handlePageChange}
        />

        {/* Right side - Modern Pagination Controls */}
        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Employee